module.exports = __webpack_public_path__ + "768495947f185cc20f43992d97153626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website-logo.png
// module id = 224
// module chunks = 1